import React from 'react'
import "./Page.css"
function Page() {
  return (
    <div className='page'>
      <div>
        <h1 className='zom-img'></h1>
      </div>
      <div className='text'>
        <h1 >Get the Zomato App</h1>
        <h4>We will send you a link, open it on your phone to download the app</h4>
        <form>
        
        <input type="radio" id="email" name="email" value="email"/>
        <label for="vehicle1"> Email</label>

        <input type="radio" id="Phone" name="Phone" value="Phone"/>
        <label for="vehicle1"> Phone</label><br/>
        
          <input type={"email"} className="email-ele"></input>
          <button className='email-btn'>Share App link</button>
        </form>
      </div>
      
    </div>
  )
}

export default Page
